import { all } from 'redux-saga/effects'
import gameSagas from './gameSagas'
import previewSagas from './previewSagas'
import metricsSagas from './metricsSagas'
import accessibilitySagas from './accessibilitySagas'

export default function* rootSaga() {
	yield all([...gameSagas, ...previewSagas, ...metricsSagas, ...accessibilitySagas])
}
